
window.addEventListener('load', () => {
    const noticeWrapper = document.body.querySelector('body > .woocommerce-notices-wrapper');
    if (!noticeWrapper) return;

    const notices = noticeWrapper.querySelectorAll(':scope > *');

    notices?.forEach(notice => {
        let close = notice.querySelector('button.close-notice');

        if (!close) {
            close = document.createElement('button');
            close.classList.add('close-notice');
            close.setAttribute('type', 'button');
            close.innerHTML = `<span class="fa-solid fa-xmark" aria-hidden="true"></span>`;
            notice.insertBefore(close, notice.firstChild);
        }

        close?.addEventListener('click', () => {
            notice.remove();
        });
    })
})